import * as T_T from 'cryface';

export namespace CreatePageValidate {
    export function validator(val: any): string {
        const errorStack: string[] = [];
        const errorPush = (err: string) => {
            errorStack.push(err);
        };
        if (!nullValidate(val.clientInfo.name.trim())) {
            errorPush('客户姓名不能为空');
        }
        if (!nullValidate(val.clientInfo.salutations.trim())) {
            errorPush('客户称谓不能为空');
        }
        if (!nullValidate(val.clientInfo.phone.trim())) {
            errorPush('客户手机号码不能为空');
        }
        if (!nullValidate(val.clientInfo.email.trim())) {
            errorPush('客户邮箱不能为空');
        }
        if (!isEmail(val.clientInfo.email.trim())) {
            errorPush('客户邮箱格式不正确');
        }
        if (!nullValidate(val.searchText.name.trim())) {
            errorPush('房源地址或MlsNumber不能为空');
        }
        if (!nullValidate(val.propetyInfo.propertyType.trim())) {
            errorPush('房源类型不能为空');
        }
        if (!nullValidate(val.propetyInfo.bedrooms.trim())) {
            errorPush('卧室数量不能为空');
        }
        if (!isDigit(val.propetyInfo.bedrooms.trim())) {
            errorPush('卧室数量必须为数字');
        }
        if (!nullValidate(val.propetyInfo.washrooms.trim())) {
            errorPush('洗手间数量不能为空');
        }
        if (!isDigit(val.propetyInfo.washrooms.trim())) {
            errorPush('洗手间数量必须为数字');
        }
        if (!nullValidate(val.propetyInfo.garages.trim())) {
            errorPush('车库数量不能为空');
        }
        if (!isDigit(val.propetyInfo.garages.trim())) {
            errorPush('车库数量必须为数字');
        }
        if (!nullValidate(val.propetyInfo.picture.trim())) {
            errorPush('房源照片不能为空');
        }
        if (val.comparitivesLen <= 0 || val.comparitivesLen > 5) {
            errorPush('对比房源至多为5个, 至少1个');
        }
        if (errorStack.length <= 0) {
            return 'validated';
        } else {
            return errorStack[0];
        }
    }

    export function nullValidate(val: any): boolean {
        return T_T.simpleDetect(val);
    }

    export function isDigit(val: string) {
        return T_T.isMatchRegex(val, /^\d+$/);
    }

    export function isEmail(val: string) {
        const emailText = val;
        const pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if (pattern.test(emailText)) {
            return true;
        } else {
            return false;
        }
    }
}
